import { Alert, Page, TextLink } from '@ui/themed';
import { t } from 'i18next';
import { INTERCOM_TRIGGER } from '../../../../constants/intercom';
import { withPageProviders } from '../../../../context/page-context';
import { CompanyInfoCard } from '../components/company-info-card';
import { PersonalInfoForm } from '../components/personal-info-form';

export const SettingsAccountPage = withPageProviders(SettingsAccountPageContent);

function SettingsAccountPageContent() {
  return (
    <Page title={t('features:account.pages.settings_account_page.title')}>
      <Alert
        variant="info"
        headingLevel="h2"
        title={t('features:account.pages.settings_account_page.update_account_notice.title')}
      >
        <span>
          {t('features:account.pages.settings_account_page.update_account_notice.description')}{' '}
          <span className={INTERCOM_TRIGGER.changeAccount}>
            <TextLink onClick={() => {}}>{t('buttons:speak_to_team')}</TextLink>
          </span>
        </span>
      </Alert>

      <PersonalInfoForm />
      <CompanyInfoCard />
    </Page>
  );
}
